import { Injectable } from "@angular/core";
import {ApiService} from '../api.service';
import {Observable} from 'rxjs';
import {StreamConfiguration} from './stream-configuration.model';
import {CreateStreamConfiguration} from './stream-configuration.create.model';

@Injectable({
  providedIn: 'root'
})
export class StreamConfigurationsService {

  constructor(
    private apiService: ApiService
  ) {
  }

  public getAll(): Observable<StreamConfiguration[]> {
    return this.apiService.get<StreamConfiguration[]>('/stream-configurations');
  }

  public getById(id: string): Observable<StreamConfiguration> {
    return this.apiService.get<StreamConfiguration>(`/stream-configurations/${id}`);
  }

  public validateStreamKey(streamKey: string): Observable<boolean> {
    return this.apiService.get(`/stream-configurations/validate/stream-key/${streamKey}`);
  }

  public create(data: CreateStreamConfiguration): Observable<StreamConfiguration> {
    return this.apiService.post<StreamConfiguration>('/stream-configurations', data);
  }

  public update(id: string, data: CreateStreamConfiguration): Observable<StreamConfiguration> {
    return this.apiService.put<StreamConfiguration>(`/stream-configurations/${id}`, data);
  }

  public delete(id: string): Observable<StreamConfiguration> {
    return this.apiService.delete<StreamConfiguration>(`/stream-configurations/${id}`);
  }
}
